import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import { getServerState } from './redux/actions/scaffolding';
import NotFound from './Screens/FallBackPages/NotFound';
import { RootNav } from './CommonComponents/index';
import Login from './Screens/Login/Login';
import AllSites from './Screens/AllSites/AllSites';
import SiteAssign from './Screens/SiteAssign/SiteAssign';
import ClientSiteAssign from './Screens/ClientReportedSites/ClientSiteAssign';
import Dashboard from './Screens/Dashboard/Dashboard';
import Monitor from './Screens/Monitor/Monitor';
import DashUser from './Screens/DashUser/DashUser';
import AssignProducts from './Screens/DashUser/AssignProducts';
import Estimates from './Screens/Estimates/Estimates';
import Supplier from './Screens/Supplier/Supplier';
import Buyer from './Screens/Buyer/Buyer';
import SyncData from './Screens/SyncData';
import PrivacyPolicy from './Screens/PrivacyPolicy/PrivacyPolicy';
import Report from './Screens/Reports/Report';
import AssignFlexDate from './Screens/AllSites/AssignFlexDate';
import MapDeletedSites from './Screens/AllSites/MapDeletedSites';
import UpdateEndDate from './Screens/AllSites/UpdateEndDate';
import MllgPrivacyPolicy from './Screens/MllgPrivacyPolicy/MllgPrivacyPolicy';
import AtaReports from './Screens/Reports/AtaReports';
import PrivateRoute from './PrivateRoute';
import AuditorSiteAssign from './Screens/AuditorReportedSites/AuditorSiteAssign';
import DefaultImages from './Screens/AllSites/DefaultImages';
import PDF from './Screens/PDF';
import SiteComparison from './Screens/SiteAssign/SiteComparison';
import SiteRapportAuditor from './Screens/SiteAssign/rapportAuditor/SiteRapportAuditor';

const useStyles = makeStyles(() => ({
  root: {
    minHeight: 'calc(100vh - 128px)',
  },
}));

const RootRouter = ({ AuthRoute }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const classes = useStyles();
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    setCurrentUser(user);
  }, [])
  const isSuperAdmin = currentUser?.id ? [345, 347, 351].includes(currentUser.id) : false;

  return (
    <Router>
      <div>
        <RootNav />
        <div className={classes.root}>
          <Switch>
            <Route path="/login">
              <Login />
            </Route>
            <AuthRoute exact path="/">
              <Dashboard />
            </AuthRoute>
            <AuthRoute exact path="/all-sites">
              <PrivateRoute
                exact
                path="/all-sites"
                component={AllSites}
                allowedRoles={['admin', 'manager', 'supplier']}
              />
            </AuthRoute>
            <AuthRoute exact path="/sites-reported">
              <PrivateRoute
                exact
                path="/sites-reported"
                component={SiteAssign}
                allowedRoles={['admin', 'buyer', 'supplier']}
              />
            </AuthRoute>
            <AuthRoute exact path="/proposed-photos">
              <PrivateRoute
                exact
                path="/proposed-photos"
                component={DefaultImages}
                allowedRoles={['admin', 'manager']}
              />
            </AuthRoute>
            <AuthRoute exact path="/reported-sites">
              <PrivateRoute
                exact
                path="/reported-sites"
                component={
                  currentUser?.userType === 'client'
                    ? ClientSiteAssign
                    : AuditorSiteAssign
                }
                allowedRoles={['client', 'auditor']}
              />
            </AuthRoute>
            <AuthRoute exact path="/site-rapport-auditor">
              <PrivateRoute
                exact
                path="/site-rapport-auditor"
                component={SiteRapportAuditor}
                allowedRoles={['rauditor']}
              />
            </AuthRoute>
            <AuthRoute exact path="/sites-comparison">
              <PrivateRoute
                exact
                path="/sites-comparison"
                component={SiteComparison}
                allowedRoles={['admin']}
              />
            </AuthRoute>
            <AuthRoute exact path="/atr-report">
              <PrivateRoute
                exact
                path="/atr-report"
                component={ClientSiteAssign}
                allowedRoles={['client', 'auditor', 'rauditor']}
              />
            </AuthRoute>

            <AuthRoute exact path="/dashboard">
              <Dashboard />
            </AuthRoute>
            <AuthRoute exact path="/buyers">
              <PrivateRoute
                exact
                path="/buyers"
                component={Buyer}
                allowedRoles={['admin', 'buyer']}
              />
            </AuthRoute>
            <AuthRoute exact path="/monitors">
              <PrivateRoute
                exact
                path="/monitors"
                component={Monitor}
                allowedRoles={['admin', 'supplier', 'manager']}
              />
            </AuthRoute>
            <AuthRoute exact path="/dash-users">
              {isSuperAdmin ? (
                <PrivateRoute
                  exact
                  path="/dash-users"
                  component={DashUser}
                  allowedRoles={['admin']}
                />
              ) : null}
            </AuthRoute>
            <AuthRoute exact path="/assign-products">
              {isSuperAdmin ? (
                <PrivateRoute
                  exact
                  path="/assign-products"
                  component={AssignProducts}
                  allowedRoles={['admin']}
                />
              ) : null}
            </AuthRoute>
            <AuthRoute exact path="/estimates">
              {isSuperAdmin ? (
                <PrivateRoute
                  exact
                  path="/estimates"
                  component={Estimates}
                  allowedRoles={['admin', 'buyer', 'manager']}
                />
              ) : null}
            </AuthRoute>
            <AuthRoute exact path="/suppliers">
              <PrivateRoute
                exact
                path="/suppliers"
                component={Supplier}
                allowedRoles={['admin', 'supplier']}
              />
            </AuthRoute>
            <AuthRoute exact path="/sync-data">
              {isSuperAdmin ? (
                <PrivateRoute
                  exact
                  path="/sync-data"
                  component={SyncData}
                  allowedRoles={['admin']}
                />
              ) : null}
            </AuthRoute>
            <AuthRoute exact path="/vendor-sites">
              <PrivateRoute
                exact
                path="/vendor-sites"
                component={AssignFlexDate}
                allowedRoles={['admin', 'supplier']}
              />
            </AuthRoute>
            <AuthRoute exact path="/report">
              <PrivateRoute
                exact
                path="/report"
                component={Report}
                allowedRoles={['admin']}
              />
            </AuthRoute>
            <AuthRoute exact path="/ata-report">
              <PrivateRoute
                exact
                path="/ata-report"
                component={AtaReports}
                allowedRoles={['admin']}
              />
            </AuthRoute>
            <AuthRoute exact path="/assign-flex-date">
              <PrivateRoute
                exact
                path="/assign-flex-date"
                component={AssignFlexDate}
                allowedRoles={['admin', 'manager', 'supplier']}
              />
            </AuthRoute>
            <AuthRoute exact path="/map-deleted-sites">
              <PrivateRoute
                exact
                path="/map-deleted-sites"
                component={MapDeletedSites}
                allowedRoles={['admin', 'manager']}
              />
            </AuthRoute>
            <AuthRoute exact path="/change-end-date">
              <PrivateRoute
                exact
                path="/change-end-date"
                component={UpdateEndDate}
                allowedRoles={['admin', 'manager']}
              />
            </AuthRoute>
            <Route path="/privacy-policy">
              <PrivacyPolicy />
            </Route>
            <Route path="/mllg-privacy-policy">
              <MllgPrivacyPolicy />
            </Route>
            <Route path="/pdf">
              <PDF />
            </Route>
            <Route>
              <NotFound />
            </Route>
          </Switch>
        </div>
      </div>
    </Router>
  );
};

const mapState = (state) => ({
  serverStatus: state.scaffoldingReducer.serverStatus,
});
const mapActions = {
  getServerState,
};

export default connect(mapState, mapActions)(RootRouter);
